/**
 * 天地图工具函数
 * 提供经纬度编解码等通用功能
 */

/**
 * 将经纬度数组编码为字符串格式
 * @param lnglat - 经纬度数组 [经度, 纬度]
 * @returns 经纬度字符串，格式为 "经度,纬度"
 * @example
 * encodeLngLat([116.404, 39.915]) // "116.404,39.915"
 */
export const encodeLngLat = (lnglat: LngLat): string => {
  return `${lnglat[0]},${lnglat[1]}`
}

/**
 * 将经纬度字符串解码为数组格式
 * @param lnglatStr - 经纬度字符串，格式为 "经度,纬度"
 * @returns 经纬度数组 [经度, 纬度]
 * @example
 * decodeLngLat("116.404,39.915") // [116.404, 39.915]
 */
export const decodeLngLat = (lnglatStr: string): LngLat | false => {
  if (!lnglatStr) {
    return false
  }
  if (!lnglatStr.includes(',')) {
    return false
  }
  const parts = lnglatStr.split(',')
  if (parts.length !== 2) {
    return false
  }
  const numParts = parts.map(part => Number(part))
  if (numParts.some(isNaN)) {
    return false
  }
  return numParts as LngLat
}
